import { render, staticRenderFns } from "./Basketball.vue?vue&type=template&id=53e4f58a&scoped=true&"
import script from "./Basketball.vue?vue&type=script&lang=js&"
export * from "./Basketball.vue?vue&type=script&lang=js&"
import style0 from "./Basketball.vue?vue&type=style&index=0&id=53e4f58a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e4f58a",
  null
  
)

export default component.exports